var pageName;
var navIndex;
var scrolled = false;
var prxObj = [];
var scrollObj = [];
var firstImageTimeout = false;
/* Highlight Nav Item
---------------------------------------------------- */

$(function(){
// remove arrows for slideshows with only a matterport or a video and add a playbutton for videos
	var url = window.location.href;
	if ( $('.slides-container li').length === 1  && ( url.indexOf('ca/northern') > 0 ))  {	
		
	 $('.slides-container').prepend('<span class="js-mediaSwipe playButton" href="https://www.youtube.com/embed/7vaHvu438Os?autoplay=1&rel=0;&controls=1&showinfo=0"></span>');
		setTimeout (function(){
			$('.slide-container a').css('display','none');
		}, 1);
	}
	if ( $('.slides-container li').length < 2 )  {	 
		setTimeout (function(){
			$('.slide-container a').css('display','none');
		}, 1);
	}
	if(url.indexOf('what-to-expect#video') > 0 ){
		setTimeout(function(){
			document.getElementById('videoCTA').click();
		},500);
	}
	if(url.indexOf('los-angeles#video') > 0 ){
		setTimeout(function(){
			document.getElementById('videoLink').click();
		},500);
	}
	if(url.indexOf("#play-video") > -1){ 
		setTimeout(function () {
	   		document.getElementById('homeVideo').click();
		}, 500);
	}
	pageName = $('body').attr('data-pagename');
    navIndex = 0; 

	// if (pageName == 'home') navIndex = 1;
	if (pageName == 'what-to-expect') navIndex = 1;
	if (pageName == 'how-to-prepare') navIndex = 2;
	if (pageName == 'design-tools') navIndex = 3;
	if (pageName == 'design-advantages') navIndex = 4;
	if (pageName == 'studio-locations') navIndex = 5;

	if (navIndex != 0) {
		var navItem = $('nav a').eq(navIndex-1).addClass('on').removeClass('off');
		setTimeout(function (argument) {
			moveLine(navItem);
			moveLine(navItem, true);
		},20)
		
	}
	

	 $(window).on('scroll',function(){
        if (window.requestAnimationFrame)
            window.requestAnimationFrame(render);
        else if (window.msRequestAnimationFrame)
            window.msRequestAnimationFrame(render);
        else if (window.webkitRequestAnimationFrame)
            window.webkitRequestAnimationFrame(render);
        else if (window.mozRequestAnimationFrame)
            window.mozRequestAnimationFrame(render);
        else if (window.oRequestAnimationFrame)
            window.oRequestAnimationFrame(render);
        else {
            QueueNewFrame = function () {};
            scrollInterval = setInterval(function(){render();}, 16.7);
        }
	});
	
	if(url.indexOf('kv=true') > -1) {
		$('body.design-advantages').addClass('kv-popup-is-visible');
	}

})

$(document).on('click', '.kitchen-visualizer-popup', function(){
	$('body.design-advantages').removeClass('kv-popup-is-visible');
});

/* Main Nav 
----------------------------------------------------*/
$('.top-bar-section a').hover(function(){
	var h = $('.nav-line');
	var a = $(this);
	//moveLine(a);
}, function() {
	var n = $('nav a.on');
	//moveLine(n);
})




/* Mobile Nav
---------------------------------------------------- */
 //Mobile Menu dropdown
        $('ul li.menu-icon a').on('click', function(e){
            e.preventDefault();
            $('nav').slideToggle('slow');
        })

/* Mobile Locations Dropdown Select
---------------------------------------------------- */
$('#studioDropdown').change(function(e){
	e.preventDefault();
	if ( $(this).val() != "" )
		window.open( $(this).val(), '_self', false );
});

/* Resize
---------------------------------------------------- */

$( window ).resize(function() {
	if ($(window).width() > 768) {
		$('nav').show();
	}else{
		$('nav').hide();
	}
	pageName = $('body').attr('data-pagename');
    navIndex = 0; 

	// if (pageName == 'home') navIndex = 1;
	if (pageName == 'what-to-expect') navIndex = 1;
	if (pageName == 'how-to-prepare') navIndex = 2;
	if (pageName == 'design-tools') navIndex = 3;
	if (pageName == 'design-advantages') navIndex = 4;
	if (pageName == 'studio-locations') navIndex = 5;
	
	if ($(window).width() > 768) {
		moveLine($('nav a').eq(navIndex-1), true);
	}


})

/* Hero CTA Effects
---------------------------------------------------- */
var d = $('.hero .design-cta');
var f = $('.image-container .your-style');
d.animate({'opacity': 1, 'margin-top': '-40px'}, 400);
f.animate({'opacity': 1, 'margin-top': '-40px'}, 400);


/* Set a split container to its childrens' height
---------------------------------------------------- */
if ( $(window).width() > 1024 ) {
	$(document).find('.split-container').each(function(){
		var container = $(this);
		var maxHeight = 0;
		container.find('.split-50').each(function(){
			if ( parseInt($(this).css('height')) > maxHeight )
				maxHeight = $(this).height();
		});
		container.css('min-height',maxHeight);
	});


	// perform effects
	var scrolledTop = $(this).scrollTop();
	$(document).find('.onScrollFadeIn').each(function(){
		if ( !$(this).hasClass('finished') ) {
			var f = $(this);
			var toTop = f.offset().top;
			if ( scrolledTop + $(window).height() > toTop + 160 ) {
				f.addClass('finished');
				setTimeout(function(){
					var oldTop = parseInt(f.css('marginTop'));
					f.css('marginTop',oldTop+50);
					f.animate({'opacity':1.0,'marginTop':oldTop},400);
				},parseInt(f.attr('data-timedelay')));
			}
		}
	});
	$(document).find('.onScrollFadeRight').each(function(){
		if ( !$(this).hasClass('finished') ) {
			var f = $(this);
			var toTop = f.offset().top;
			if ( scrolledTop + $(window).height() > toTop + 160 ) {
				f.addClass('finished');
				setTimeout(function(){
					var oldLeft = parseInt(f.css('left'));
					f.css('left', oldLeft - 200);
					f.animate({'opacity':1.0,'left':oldLeft},400);
				},parseInt(f.attr('data-timedelay')));
			}
		}
	});
	$(document).find('.onScrollFadeLeft').each(function(){
		if ( !$(this).hasClass('finished') ) {
			var f = $(this);
			var toTop = f.offset().top;
			if ( scrolledTop + $(window).height() > toTop + 160 ) {
				f.addClass('finished');
				setTimeout(function(){
					var oldRight = parseInt(f.css('right'));
					f.css('right', oldRight - 200);
					f.animate({'opacity':1.0,'right':oldRight},400);
				},parseInt(f.attr('data-timedelay')));
			}
		}
	});
}



/* Slideshow Events
---------------------------------------------------- */
var rotationBannerTimer;
$(document).on('click', '.slideshow .arrow', function(e) {
	e.preventDefault();
	var direction = ($(this).hasClass('left')) ? -1 : 1;
	switchSlide( $(this).parent(), direction );
	clearInterval( rotationBannerTimer );
});
function switchSlide( slideshow, direction ) {
	var currentSlide = slideshow.find('.banner-image.on').index();
	var totalSlides = slideshow.find('.banner-image').length;
	var nextSlideIndex = currentSlide + direction;
	if ( nextSlideIndex < 0 ) nextSlideIndex = totalSlides - 1;
	if ( nextSlideIndex >= totalSlides ) nextSlideIndex = 0;
	var nextSlide = slideshow.children('.banner-image').eq( nextSlideIndex );
	currentSlide = slideshow.find('.banner-image.on');
	nextSlide.css('opacity',0.0).addClass('on').removeClass('off');
	currentSlide.css('opacity',1.0).removeClass('on').addClass('off');
	nextSlide.stop(true,false).animate({'opacity':1.0},400);
	currentSlide.stop(true,false).animate({'opacity':0.0},400);

}


/* Images preloader
---------------------------------------------------- */
var images = [];
var imagesLoaded = 0;
$(document).find('.banner-image').each(function(){
	var wWidth = $(window).width();
	
	
	var path;
	if ( wWidth > 500 )
		path = $(this).attr('data-filename');
	else {
		var filepath = $(this).attr('data-filename');
		filepath = filepath.split('/');
		var filename = 'mobile_' + filepath[ filepath.length-1] ;
		filepath[ filepath.length-1 ] = filename;
		filepath = filepath.join('/');
		path = filepath;
	}
		
	
	var i = images.length;
	images[i] = { imageObj : new Image(), domObj : $(this) }
	images[i]['imageObj'].onload = function(){
		imagesLoaded++;
		if ( imagesLoaded == images.length ){
			for ( var p = 0; p < images.length; p++ ) {
				var domObj = images[p]['domObj'];
				domObj.addClass('preloaded');
				var container = domObj.parent();
				domObj.attr('src', images[p]['imageObj'].src );
				
				domObj.css({'height':'inherit'}); // ie issue for resizing
				
				var imgRatio = images[p]['imageObj'].width / images[p]['imageObj'].height;
				
				var containerRatio = container.width() / container.height();
				
				if ( imgRatio > containerRatio ) {
					domObj.css({'height':container.height()+'px','width':container.height()*imgRatio+'px','top':0});
				} else {
					var newHeight = container.width() / imgRatio;
					domObj.css({'width':container.width()+'px','height': newHeight+'px','top': (container.height() - newHeight) / 2});
				}
				
				domObj.fadeIn();
			}
			// Auto Rotate any banners
			if ( $('.banners.slideshow').length ) {
				rotationBannerTimer = setInterval(function(){
					switchSlide( $('.banners.slideshow'), 1);
				}, 4500);
			}
			
			// if homepage, load in animations
			if ( $('body.home').length || $('body.what-to-expect').length ) {
				setTimeout(function(){
					var cta = $('.banner-container .cta');
					var ctaI = $('.banner-sloped-container .cta');
					var top = parseInt(cta.css('top'));
					if ( top < 50 ) 
						top = $('.banner-container').height()/2;
					cta.css({'top': top+20});
					cta.animate({'opacity':1.0,'top':top},400);
					var topI = parseInt(ctaI.css('top'));
					ctaI.css({'top': top+20});
					ctaI.animate({'opacity':1.0,'top':top},400);
				},650);
			}
		}
	}
	images[i]['imageObj'].src = path;
});
$(window).resize(function(){
	$(document).find('.banner-image.preloaded').each(function(){
		var domObj = $(this);
		var container = domObj.parent();
		
		var imgRatio = domObj.width() / domObj.height();
		var containerRatio = container.width() / container.height();
		
		if ( imgRatio > containerRatio ) {
			domObj.css({'height':container.height()+'px','width':container.height()*imgRatio+'px','top':0});
		} else {
			var newHeight = container.width() / imgRatio;
			domObj.css({'width':container.width()+'px','height': newHeight+'px','top': (container.height() - newHeight) / 2});
		}
	});
	
	$(document).find('.split-container').each(function(){
		var container = $(this);
		var maxHeight = 0;
		container.find('.split-50').each(function(){
			if ( parseInt($(this).css('height')) > maxHeight )
				maxHeight = $(this).height();
		});
		container.css('min-height',maxHeight);
	});
	
	$(document).find('.banner-container .cta').each(function(){
		$(this).css({'top':'50%','marginTop':'-33px'}); 
	});
	
	$(document).find('.banner-sloped-container .lead-in').each(function(){
		$(this).css({'top':'50%','marginTop': (-1 * $(this).height()/2) - 10}); 
	});
});




/* Get geolocation for directions
---------------------------------------------------- */
if($('body').hasClass('directions') && navigator.geolocation) {
	$('#TBMap_Form_Buttons').prepend('<input type="button" id="get_location" value="Get Location"/>');
	$(document).on('click','#get_location',function() {
		navigator.geolocation.getCurrentPosition(showPosition);
	});
	$(document).on('click','#get_directions',function() {
		$('#get_location').remove(); 
		$(this).css({'position':'absolute'});
	});
} 



/* Page Effects
---------------------------------------------------- */
if ( $(window).width() > 1024 ) {
	window.addEventListener('scroll', function() {
		// perform parallax effects
		var scrolledTop = $(this).scrollTop();
		$(document).find('.onScrollFadeIn').each(function(){
			if ( !$(this).hasClass('finished') ) {
				var f = $(this);
				var toTop = f.offset().top;
				if ( scrolledTop + $(window).height() > toTop + 160 ) {
					f.addClass('finished');
					setTimeout(function(){
						var oldTop = parseInt(f.css('marginTop'));
						f.css('marginTop',oldTop+50);
						f.animate({'opacity':1.0,'marginTop':oldTop},400);
					},parseInt(f.attr('data-timedelay')));
				}
			}
		});
		$(document).find('.onScrollFadeRight').each(function(){
			if ( !$(this).hasClass('finished') ) {
				var f = $(this);
				var toTop = f.offset().top;
				if ( scrolledTop + $(window).height() > toTop + 160 ) {
					f.addClass('finished');
					setTimeout(function(){
						var oldLeft = parseInt(f.css('left'));
						f.css('left', oldLeft - 200);
						f.animate({'opacity':1.0,'left':oldLeft},400);
					},parseInt(f.attr('data-timedelay')));
				}
			}
		});
		$(document).find('.onScrollFadeLeft').each(function(){
			if ( !$(this).hasClass('finished') ) {
				var f = $(this);
				var toTop = f.offset().top;
				if ( scrolledTop + $(window).height() > toTop + 160 ) {
					f.addClass('finished');
					setTimeout(function(){
						var oldRight = parseInt(f.css('right'));
						f.css('right', oldRight - 200);
						f.animate({'opacity':1.0,'right':oldRight},400);
					},parseInt(f.attr('data-timedelay')));
				}
			}
		});
	});
}



/* Design Tools */
$(function(){
	
	if ( $('.kitchens').length ) {
		var k = $('.kitchens');
		$.ajax({
			url:	'https://www.tollbrothers.com/api/galleries/kitchen/north',
			dataType: "jsonp"
		}).done(function(d){
			d.sort(function(a,b) {
		        if ( a['city'] > b['city'] ) return 1;
		        else if ( a['city'] < b['city'] ) return -1;
		        else return 0;
    		})

			
			var htmls = '';
			var im = d[0]['images'][0]['S920x630']
			for( var i = 0; i < d.length; i++ ) {
				var img = d[i]['images'][0]['S920x630'];
				
				
				if ( i == 0 )
					htmls += '<li class="current" data-caption="' + d[i]['communityName'] +'"><img src="' + img + '" data-filename="' + img + '" data-description="' + d[i]['communityName'] + '" alt="" /></li>';
				else
					htmls += '<li data-caption="' + d[i]['communityName'] +'"><img src="' + img + '" data-filename="' + img + '" data-description="' + d[i]['communityName'] + '" alt="" /></li>';
			}
			$('.kitchens').find('.slides-container').html( htmls );

			
			
			setUpSlides(true);
			
			k.find('.slide-caption').text(k.find('li.current').eq(0).data('caption'));
			
			var b = $('.bathrooms');
			$.ajax({
				url:	'https://www.tollbrothers.com/api/galleries/bathroom/north/',
				dataType: "jsonp"
			
			}).done(function(d){
				d.sort(function(a,b) {
		        if ( a['city'] > b['city'] ) return 1;
		        else if ( a['city'] < b['city'] ) return -1;
		        else return 0;
    		})
				
				var htmls = '';
				for( var i = 0; i < d.length; i++ ) {
					var img = d[i]['images'][0]['S920x630'];


					
					if ( i == 0 )
						htmls += '<li class="current" data-caption="' + d[i]['communityName'] +'"><img src="' + img + '" data-filename="' + img + '" data-description="' + d[i]['communityName'] + '" alt="" /></li>';
					else
						htmls += '<li data-caption="' + d[i]['communityName'] +'"><img src="' + img + '" data-filename="' + img + '" data-description="' + d[i]['communityName'] + '" alt="" /></li>';
				}
				$('.bathrooms').find('.slides-container').html( htmls );
				setUpSlides(true);
				b.find('.slide-caption').text(b.find('li.current').eq(0).data('caption'));
			});
		});
	}
});

var parentContainer;
$(document).on('click', '.gallery-locations a', function(e){
	e.preventDefault();
	if ( $(this).hasClass('on') )
		return false;
		
	$(this).parent().find('a.on').removeClass('on');
	$(this).addClass('on');

	var p = $(this).parent().parent();
	
	
	var region = '';
	var type = ( $(this).parent().parent().hasClass('kitchens') ) ? 'kitchen' : 'bathroom';
	
	switch( $(this).index() ) {
		case 0:	region = 'north';
				break;
		case 1: region = 'midatlantic';
				break;
		case 2: region = 'south';
				break;
		case 3:	region = 'west';
				break;
	}

	
	var apiCall = 'https://www.tollbrothers.com/api/galleries/' + type + '/' + region;
	parentContainer = $(this).parent().parent();
	parentContainer.find('.slides-container').html('');
	
	$.ajax({
		url:	apiCall,
		dataType: "jsonp"
	
	}).done(function(d){
		
		var htmls = '';
		for( var i = 0; i < d.length; i++ ) {
			var img = d[i]['images'][0]['S920x630'];
			
			if ( i == 0 )
				htmls += '<li class="current" data-caption="' + d[i]['communityName'] +'"><img src="' + img + '" data-filename="' + img + '" data-description="' + d[i]['communityName'] + '" alt="" /></li>';
			else
				htmls += '<li data-caption="' + d[i]['communityName'] +'"><img src="' + img + '" data-filename="' + img + '" data-description="' + d[i]['communityName'] + '" alt="" /></li>';
		}
		parentContainer.find('.slides-container').html( htmls );
		setUpSlides(true);
		parentContainer.find('.slide-caption').text(parentContainer.find('li.current').eq(0).data('caption'));
	});
});



var galleryImages = [];
var galleryImagesLoaded = 0;

function preloadDesignToolImagery() {
	$(document).find('.gallery-image-preload').each(function(){
		var path = $(this).attr('data-filename');
		var i = galleryImages.length;
		galleryImages[i] = { imageObj : new Image(), domObj : $(this) }
		galleryImages[i]['imageObj'].onload = function(){
			galleryImagesLoaded++;
			if ( galleryImagesLoaded == galleryImages.length ){
				for ( var p = 0; p < galleryImages.length; p++ ) {
					var domObj = galleryImages[p]['domObj'];
					domObj.addClass('preloaded');
					var container = domObj.parent();
					domObj.attr('src', galleryImages[p]['imageObj'].src );
					
					var imgRatio = domObj.width() / domObj.height();
					var containerRatio = container.width() / container.height();
					
					if ( imgRatio > containerRatio ) {
						domObj.css({'height':container.height(),'width':container.height()*imgRatio,'top':0});
					} else {
						var newHeight = container.width() / imgRatio;
						domObj.css({'width':container.width(),'height': newHeight,'top': (container.height() - newHeight) / 2});
					}
					
					domObj.show();
				}
			}
		}
		galleryImages[i]['imageObj'].src = path;
	});
}

$(window).resize(function(){
	$(document).find('.gallery-image-preload.preloaded').each(function(){
		var domObj = $(this);
		var container = domObj.parent();
		
		var imgRatio = domObj.width() / domObj.height();
		var containerRatio = container.width() / container.height();
		
		if ( imgRatio > containerRatio ) {
			domObj.css({'height':container.height()+'px','width':container.height()*imgRatio+'px','top':0});
		} else {
			var newHeight = container.width() / imgRatio;
			domObj.css({'width':container.width()+'px','height': newHeight+'px','top': (container.height() - newHeight) / 2});
		}
	});
});

function switchGallerySlide( slideshow, direction ) {
	var currentSlide = slideshow.find('.gallery-image-preload.on').index();
	var totalSlides = slideshow.find('.gallery-image-preload').length;
	var nextSlideIndex = currentSlide + direction;
	if ( nextSlideIndex < 0 ) nextSlideIndex = totalSlides - 1;
	if ( nextSlideIndex >= totalSlides ) nextSlideIndex = 0;
	var nextSlide = slideshow.children('.gallery-image-preload').eq( nextSlideIndex );
	currentSlide = slideshow.find('.gallery-image-preload.on');
	nextSlide.css('opacity',0.0).addClass('on').removeClass('off');
	currentSlide.css('opacity',1.0).removeClass('on').addClass('off');
	nextSlide.stop(true,false).animate({'opacity':1.0},400);
	currentSlide.stop(true,false).animate({'opacity':0.0},400);
	
	/* switch thumbnails */
	var nextSlidePreview = nextSlideIndex + 1;
	if ( nextSlidePreview < 0 ) nextSlidePreview = totalSlides - 1;
	if ( nextSlidePreview >= totalSlides ) nextSlidePreview = 0;
	var previousSlidePreview = nextSlideIndex - 1;
	if ( previousSlidePreview < 0 ) previousSlidePreview = totalSlides - 1;
	if ( previousSlidePreview >= totalSlides ) previousSlidePreview = 0;
	slideshow.parent().find('.arrow.right .the-image').css('background-image', 'url('+slideshow.children('img').eq(nextSlidePreview).attr('data-filename')+')' );
	slideshow.parent().find('.arrow.left .the-image').css('background-image',  'url('+slideshow.children('img').eq(previousSlidePreview).attr('data-filename')+')' );
	
	/* switch description tag */
	slideshow.parent().find('.description-tag').html( nextSlide.attr('data-description') );
}

$(document).on('click', '.gallery-imagery .arrow', function(e){
	e.preventDefault();
	var direction = ($(this).hasClass('left')) ? -1 : 1;
	switchGallerySlide ( $(this).parent().find('.gallery-imagery-container'), direction );
});


onPlayerReady = function(event) {
	event.target.playVideo();
	//ytVideo.mute();
}


/* ipad touch events fixes */
$(document).on('touchend', '.cta a', function(e){
	if ( $(this).parent().attr('id') != 'videoCTA' )
	window.location = $(this).attr('href');
});
$(document).on('touchend', '.cta2 a', function(e){
	window.location = $(this).attr('href');
});

function moveLine(a, b) {
	if ( !$('.nav-line').length ) {
		return false;
	}
	var h = $('.nav-line');
	var l = a.offset().left
	var w = (a.width()/2)-6;
	var n = ($(document).width() - $('.top-bar-section').width()) / 2;
	h.css({'margin-left': l-n+w+'px'});
	if(b) {
		var on = $('.nav-line-on');
		on.css({'margin-left': l-n+w+'px'});
	}
}

function render() {
            windowWidth = $(window).width()
            windowHeight = $(window).height();
            var position = $(window).scrollTop();
            var documentHeight = $(document).height();
            var m = $('.main-header');
            var mh = m.height();
            var pageName = $('body').attr('data-pagename');
            var n = $('nav');
            var h = $('.hero');
            

           
         

            if(scrolled === false) {
                
              $('.flex-items').each(function(index) {
                var pObj = {
                    top: $(this).offset().top,
                    height: $(this).height(),
                    id: $(this).attr('id'),
                    direction: $(this).hasClass('slide-down') ? -1 : 1
                }

              scrollObj.push(pObj);
            })

              $('.your-style').each(function(index) {
                var pObj = {
                    top: $(this).offset().top,
                    height: $(this).height(),
                    id: $(this).attr('id'),
                }

              	prxObj.push(pObj);
            })

           	scrolled = true;
            
            }



            if(windowWidth > 769) {

				if ( $('body').hasClass('studio-locations') ) {
					var position = $(window).scrollTop() + 40;
				} else {
					var position = $(window).scrollTop();
				}

            // if(position >= documentHeight - $(window).height() - 100) {
            //     $('.main-footer').show().animate({'bottom': 0}, 300);
            // }

				var offset = m.offset();
				
                if ( position > (m.height() - n.height())) { 
                    if(!n.hasClass('fixed')) {
                    	n.addClass('fixed');
                    	h.addClass('margin-75');
                    }
                }

                if(position <= m.height()) {
                    n.removeClass('fixed');
                    h.removeClass('margin-75');
				}
                
                for(i=0; i<scrollObj.length; i++) {
                    var divT = scrollObj[i].top - (windowHeight);
                    var areaS = scrollObj[i].top + (scrollObj[i].height);
                    
                    if(position > divT && position <= areaS) {
                        
                        scrollObj[i].direction == -1 ? $('#'+scrollObj[i].id).addClass('animate-down') : $('#'+scrollObj[i].id).addClass('animate-up');
                    }else{
                       scrollObj[i].direction == -1 ? $('#'+scrollObj[i].id).removeClass('animate-down') :$('#'+scrollObj[i].id).removeClass('animate-up');
                    
                    }
                }

                for(i=0; i<prxObj.length; i++) {
                    var divT = prxObj[i].top - (windowHeight);
                    var areaS = prxObj[i].top + (prxObj[i].height);
                    
                    if(position > divT && position <= areaS) {
                        
                        prxObj[i].direction == -1 ? $('#'+prxObj[i].id).addClass('animate-down') : $('#'+prxObj[i].id).addClass('animate-up');
                    }else{
                       prxObj[i].direction == -1 ? $('#'+prxObj[i].id).removeClass('animate-down') :$('#'+prxObj[i].id).removeClass('animate-up');
                    
                    }
                }
        	}
}

/* ===========================================================
	PAGE SCROLL
============================================================*/

$(document).on('click', '.js-inbound-link', function(e) {
	if ( $('body').hasClass('studio-locations') ) {
		var destination = $('#'+ $(this).attr('data-section')).offset().top;
		$('body,html').animate({ scrollTop : destination }, 800);
	}
});

if ( $('body').hasClass('design-tools') ) {
	$(document).on('click', '.js-page-scroll', function(){
		var destination = $('.'+ $(this).attr('data-scrollTo')).offset().top;
    	$('body,html').animate({ scrollTop : destination });
	});
}